var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.927 10.5397L17.3584 8.92984C17.8619 7.05061 18.1137 6.11099 17.9241 5.29785C17.7744 4.6558 17.4376 4.07256 16.9565 3.62189C16.3471 3.05112 15.4074 2.79935 13.5282 2.29581C11.649 1.79227 10.7093 1.5405 9.8962 1.7301C9.25416 1.8798 8.67092 2.21654 8.22024 2.69771C7.73156 3.21948 7.47672 3.9833 7.09749 5.37167C7.03379 5.60488 6.96658 5.85571 6.89417 6.12597L6.4628 7.73585C5.95926 9.61508 5.70749 10.5547 5.89709 11.3678C6.0468 12.0099 6.38353 12.5931 6.86471 13.0438C7.47411 13.6146 8.41372 13.8663 10.2929 14.3699L10.293 14.3699C11.9868 14.8237 12.9173 15.0731 13.6798 14.979C13.7633 14.9687 13.8447 14.9543 13.925 14.9356C14.567 14.7859 15.1502 14.4492 15.6009 13.968C16.1717 13.3586 16.4235 12.419 16.927 10.5397Z",
    stroke: "#A020FF",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6785 14.9784C13.5048 15.5105 13.1993 15.9918 12.7885 16.3766C12.1791 16.9473 11.2395 17.1991 9.36023 17.7026C7.481 18.2062 6.54138 18.4579 5.72824 18.2683C5.08619 18.1186 4.50295 17.7819 4.05228 17.3007C3.48151 16.6913 3.22974 15.7517 2.7262 13.8725L2.29483 12.2626C1.79129 10.3834 1.53952 9.44375 1.72912 8.6306C1.87883 7.98856 2.21556 7.40532 2.69674 6.95464C3.30614 6.38387 4.24576 6.13211 6.12499 5.62857C6.48052 5.5333 6.80242 5.44705 7.09619 5.37109",
    stroke: "#A020FF",
    strokeWidth: 1.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.a6274f13a43efa2c2400e0970435c59e.svg";
export { ForwardRef as ReactComponent };